import { render, staticRenderFns } from "./GroupComment.vue?vue&type=template&id=0bce91f9&scoped=true&"
import script from "./GroupComment.vue?vue&type=script&lang=js&"
export * from "./GroupComment.vue?vue&type=script&lang=js&"
import style0 from "./GroupComment.vue?vue&type=style&index=0&id=0bce91f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bce91f9",
  null
  
)

export default component.exports